import { ActionType, TableStateSnapshot } from '../shared/types';

/**
 * Клиентское "зеркало" серверной логики getLegalActions — нужно только для UI
 * (какие кнопки показать). Финальная валидация действия ВСЕГДА происходит на
 * сервере в PokerTable.applyAction — если клиент здесь ошибётся, сервер просто
 * отклонит действие и пришлёт error.
 */
export function computeLegalActions(state: TableStateSnapshot, viewerId: string) {
  const empty = { types: [] as ActionType[], minRaiseTo: 0, maxRaiseTo: 0, callAmount: 0 };
  if (state.actingPlayerId !== viewerId) return empty;

  const me = state.players.find((p) => p.id === viewerId);
  if (!me) return empty;

  const callAmount = Math.max(0, state.currentBetToCall - me.betInStreet);
  const types: ActionType[] = ['fold'];
  if (callAmount <= 0) types.push('check');
  if (callAmount > 0) types.push('call');

  const maxRaiseTo = me.betInStreet + me.stack;
  if (me.stack > callAmount) {
    types.push(state.currentBetToCall === 0 ? 'bet' : 'raise');
  }
  if (me.stack > 0) types.push('all-in');

  return {
    types,
    minRaiseTo: state.minRaiseTo,
    maxRaiseTo,
    callAmount,
  };
}
